import React from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import EventTooltipPanel from './EventTooltipPanel';

const EventHoverTooltip = ({
  eventId,
  events,
  openEventPage,
  openPlaylistPage,
  hasOutputs,
  trigger,
  isNhlUser,
  userClubId,
}) => {
  const opRef = React.useRef(null);

  const toggleTooltip = event => {
    event.stopPropagation(); // it's important that FullCalendar doesnt catch click

    if (opRef.current) {
      opRef.current.toggle(event);
    }
  };

  const onTriggerKeyDown = event => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    event.preventDefault();
    toggleTooltip(event);
  };

  return (
    <>
      <span
        className="calendarEventTooltipTrigger"
        onClick={toggleTooltip}
        onKeyDown={onTriggerKeyDown}
        role="button"
        tabIndex={0}
        aria-label="Event details"
      >
        {/* {hasOutputs ? (
          <i className="pi pi-external-link calendarEventTooltipIconBlue" />
        ) : (
          <i className="pi pi-external-link calendarEventTooltipIconGrey" />
        )} */}
        {trigger || (
          <i
            className={
              hasOutputs
                ? 'pi pi-external-link calendarEventTooltipIconBlue'
                : 'pi pi-external-link calendarEventTooltipIconGrey'
            }
          />
        )}
      </span>

      <OverlayPanel
        ref={opRef}
        appendTo={document.body}
        dismissable
        showCloseIcon={false}
        className="calendarEventOverlayPanel"
      >
        <EventTooltipPanel
          id={eventId}
          events={events}
          openEventPage={openEventPage}
          openPlaylistPage={openPlaylistPage}
          isNhlUser={isNhlUser}
          userClubId={userClubId}
          onClose={() => opRef.current && opRef.current.hide()}
        />
      </OverlayPanel>
    </>
  );
};

export default EventHoverTooltip;
